var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopScoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9287_122339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5587 4.44528L14.912 7.09713C15.3479 7.95129 16.1659 8.54559 17.113 8.69621L20.0532 9.16383C20.8596 9.29208 21.1807 10.2804 20.6037 10.8581L18.4998 12.9646C17.8222 13.6432 17.5098 14.6047 17.6592 15.552L18.123 18.4929C18.2502 19.2994 17.4095 19.9102 16.6818 19.54L14.0282 18.19C13.1735 17.7552 12.1624 17.7552 11.3077 18.19L8.65413 19.54C7.9264 19.9102 7.08571 19.2994 7.21292 18.4929L7.67677 15.552C7.82618 14.6047 7.51374 13.6432 6.83609 12.9646L4.73223 10.8581C4.15526 10.2804 4.47638 9.29208 5.28272 9.16383L8.22298 8.69621C9.17004 8.54559 9.98802 7.95129 10.4239 7.09713L11.7773 4.44528C12.1484 3.71803 13.1875 3.71803 13.5587 4.44528Z",
    stroke: "#FFA443",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9287_122339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.667969 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopScoreIcon);
export default __webpack_public_path__ + "static/media/top_score_icon.4572cf6626487f2155620f7b7f8a7b7e.svg";
export { ForwardRef as ReactComponent };